"use client";

import { useField } from "formik";
import dynamic from "next/dynamic";
import React, { useState } from "react";
const TECollapse = dynamic(() =>
  import("tw-elements-react").then((res) => res.TECollapse)
);
function SelectAccordion({
  name,
  options,
  placeholder,
  onChange,
  value,
  label,
  color,
  labelClassName,
}: SelectAccordionPropsType) {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => setIsOpen(false);
  const toggleOpen = () => setIsOpen(!isOpen);
  const [, meta] = useField({ name });

  const selected = options.find((v) => v.value == value)?.key;
  const error = meta.touched && meta.error;
  return (
    <>
      {" "}
      <div className="flex w-full  ">
        <label className="lg:text-[1.5rem] lg:flex hidden  lg:!w-[20rem] w-[203px] lg:mt-[.4rem] text-[14px] text-[#220859] font-light">
          {label}
        </label>
        <div className="w-full ">
          {" "}
          <div
          style={{borderColor:!error?color:""}}
            className={`border-secondary  w-full  lg:text-[1.25rem] font-medium  text-[14px] bg-[#FAFAFA] px-[20px] lg:pe-[0.875rem] lg:ps-[1.875rem] py-[8px] lg:py-[0.812rem] shadow-select border-[1px] rounded-[30px] ${
              error && " !border-rose-500"
            }`}
          >
            <p className="mb-0  " id="headingOne">
              <button
                className={` group relative flex  w-full items-center min-h-[48px] `}
                type="button"
                onClick={toggleOpen}
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <span
                  style={{backgroundColor:color}}
                  className={`${
                    isOpen ? `rotate-180` : `   `
                  } h-[24px] w-[24px] lg:h-[28px] lg:w-[28px] flex items-center absolute end-0 justify-center  bg-secondary rounded-full shrink-0  transition-transform duration-100 ease-in-out motion-reduce:transition-none `}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8.83"
                    height="8.83"
                    viewBox="0 0 15.109 8.377"
                  >
                    <path
                      id="Path_49625"
                      data-name="Path 49625"
                      d="M-14235-22930l5.834,5.359,5.742-5.359"
                      transform="translate(-14221.657 -22923.391) rotate(180)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2.5"
                    />
                  </svg>
                </span>
                {selected ? (
                  <span className="font-bold">{selected}</span>
                ) : (
                  placeholder
                )}
              </button>
            </p>
            <TECollapse
              show={isOpen}
              translate="no"
              className="!mt-4  !shadow-none block  "
            >
              <div className="max-h-[200px] overflow-y-scroll">
                {" "}
                {options.map((op, index) => (
                  <p
                    onClick={() => {
                      onChange(op.value);
                      handleClose();
                    }}
                    key={index}
                    className={`cursor-pointer transition-all duration-300 lg:mb-[1rem] mb-[10px] ${
                      op.value == value && " font-bold"
                    }`}
                  >
                    {op.key}
                  </p>
                ))}
              </div>
            </TECollapse>
          </div>
          <div className="text-rose-500 text-[12px] h-10 mt-1  lg:text-[1.25rem]">
            {error ? meta.error : ""}
          </div>
        </div>
      </div>
    </>
  );
}

export default SelectAccordion;

type SelectAccordionPropsType = {
  options: {
    value: string;
    key: string;
  }[];
  name: string;
  color?: string;
  value: string;
  labelClassName?: string;

  label: string;
  onChange: (value: string) => void;
  placeholder: string;
};
